export enum MediaType {
  PHOTO = 'PHOTO',
  ANIMATION = 'ANIMATION', // gif
  VIDEO = 'VIDEO',
}

export interface ShareData {
  telegramId?: number;
  mediaType: MediaType;
  mediaId: string;
  text?: string;
  buttonText?: string;
  buttonUrl?: string;
  gameKey?: string;
}

export type ShareVariants = 'REFERRAL' | 'GAME';
